import React from 'react'
import event from '@/utils/event'
import { Inscription } from '@/utils/types/inscription'

interface OpenArgs {
	id: string
	inscription?: Inscription | any
}

export default function useInscriptionModal() {
	return React.useCallback((args: OpenArgs | string, evt?: any) => {
		evt?.preventDefault?.()
		evt?.stopPropagation?.()

		const payload: OpenArgs = typeof args === 'string' ? { id: args } : args
		event.emit('open-inscription-modal', payload)
	}, [])
}
